export default __webpack_public_path__ + "static/media/img_12.db97d20f.JPG";